import { Flex, Button, Text } from "@chakra-ui/react";
import { useContext } from "react";

import { FilterDetailsContext } from "../filter-details-context";

export const FilterByValueHeader = () => {
  const { paginationDetails, onSelectAll, filterItems, onClear } =
    useContext(FilterDetailsContext)!;

  const { isLoading, isPaginating, totalValuesCount } = paginationDetails;

  return (
    <Flex className="justify-between items-center mb-2.5">
      <Flex className="items-center space-x-2">
        <Button
          isDisabled={isLoading || isPaginating}
          onClick={onSelectAll}
          size="xs"
          variant="ghost"
        >
          Select all {totalValuesCount ? ` ${totalValuesCount}` : ""}
        </Button>
        <Button
          isDisabled={isLoading || isPaginating}
          onClick={onClear}
          size="xs"
          variant="ghost"
        >
          Clear
        </Button>
      </Flex>
      <Text className="text-gray-900 text-[13px]">
        Displaying {filterItems?.length ?? 0}
      </Text>
    </Flex>
  );
};
